import schema from './schema'

export default {
  schema,
}
